import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@core/modals/modal-registry.token';
import { WIN_MODAL_KEY } from '@core/constants/win-modal.constants';
import { WinModalComponent } from './win-modal.component';

export function provideWinModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: WIN_MODAL_KEY, component: WinModalComponent }, multi: true },
  ];
}
